<template>
  <div v-html="apply"></div>
</template>

<script>
import { $t } from '@/locales'

export default {
  name: 'applyText',
  data() {
    return {
      apply: '',
    }
  },
  methods: {
    thirdPay() {
      const returnUrl = window.location.origin
      const thirdPayMode = 'ALIPAY'

      return this.$ajax(this.$url.payInvitationspagePay(this.$route.query.invitationId), { returnUrl, thirdPayMode }, false).catch(err => {
        this.$alert(err.message, $t('提示'), {
          confirmButtonText: $t('确定'),
          type: 'error',
          dangerouslyUseHTMLString: true,
          showClose: false,
        }).then(() => {
          window.location.href = 'https://www.esign.cn/'
        })
      })
    },
  },
  async mounted() {
    let form = this.$route.query.htmls
    if (this.$route.query.getThirdPayment) {
      const resThirdPartPayment = await this.thirdPay()
      form = resThirdPartPayment.data
    }
    form = form.split(' target="_blank"').join('')
    this.apply = form
    this.$nextTick(() => {
      document.forms[0].submit()
    })
  },
}
</script>
